import { merge } from "lodash";

import dashboardResolvers from "../modules/forecast/modules/demand-editor/pages/dashboard/resolvers";

export default merge(dashboardResolvers);
